// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
// initialize an empty api service that we'll inject endpoints into later as needed
export const publicApi = createApi({
    reducerPath: "api/public",
    // Set a default timeout of 10 seconds
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE_URL,
        timeout: 10000,
        prepareHeaders: (headers) => {
            return headers
        },
    }),
    endpoints: () => ({}),
})
